module.exports = __webpack_public_path__ + "static/media/a3f5c359-15ea-4fcf-a4d4-b2d5c58c5c2f.bef1e24f.JPG";